/**
 * Roadmap Item Remapper
 * Flutter: lib/data/models/roadmap_item.dart (+ roadmap_item.g.dart)
 *
 * Bridges raw Firestore JSON → RoadmapItemDto. There are no @JsonKey
 * overrides in Flutter, so each Firestore field name equals the Dart
 * property name. Late (required) fields get Flutter-equivalent defaults
 * ('' for String, 0 for int/double); nullable fields stay undefined.
 */
import type { RoadmapItemDto } from '@/data/dtos/roadmapItem/roadmapItemDto';
import type { JsonObject } from '@/data/types/json';

export class RoadmapItemRemapper {
  static fromJson(data: JsonObject): RoadmapItemDto {
    return {
      id: (data['id'] as string | undefined) ?? '',
      title: (data['title'] as string | undefined) ?? '',
      description: data['description'] as string | undefined,
      createdTimestamp: data['createdTimestamp'] as number | undefined,
      dueTimestamp: data['dueTimestamp'] as number | undefined,
      order: (data['order'] as number | undefined) ?? 0,
      status: (data['status'] as number | undefined) ?? 0,
      userId: (data['userId'] as string | undefined) ?? '',
      userName: (data['userName'] as string | undefined) ?? '',
      likes: (data['likes'] as number | undefined) ?? 0,
      dislikes: (data['dislikes'] as number | undefined) ?? 0,
      comments: (data['comments'] as number | undefined) ?? 0,
      usd: (data['usd'] as number | undefined) ?? 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): RoadmapItemDto[] {
    return dataList.map(RoadmapItemRemapper.fromJson);
  }
}
